import { type Dispatch, type FC, type SetStateAction, useState } from 'react'
import { useTranslation } from '@egw/i18n'
import InitStep from './init-step'
import ActivateCard from './activate-card'

export enum ActivateCardStepEnum {
  INIT = 'INIT',
  ACTIVATE = 'ACTIVATE',
}

export const TRANSLATION_KEY_PREFIX = 'debit_card.activate.'

export interface TFlowModals {
  title: string
  cardId: string
  step: ActivateCardStepEnum
  setStep: Dispatch<SetStateAction<ActivateCardStepEnum>>
  setModalTitle: (title: string) => void
  closeModal: () => void
  alias: string
}

interface ActivatePhysicalCardProps {
  cardId: string
  setModalTitle: (title: string) => void
  closeModal: () => void
  alias: string
}

const ActivatePhysicalCard: FC<ActivatePhysicalCardProps> = ({ cardId, setModalTitle, closeModal, alias }) => {
  const { t } = useTranslation('features-account')

  const [step, setStep] = useState<ActivateCardStepEnum>(ActivateCardStepEnum.INIT)

  const title = t(`${TRANSLATION_KEY_PREFIX}${step}.title`)
  setModalTitle(title)

  const props: TFlowModals = {
    title,
    setStep,
    cardId,
    step,
    setModalTitle,
    closeModal,
    alias,
  }

  return {
    [ActivateCardStepEnum.INIT]: <InitStep {...props} />,
    [ActivateCardStepEnum.ACTIVATE]: <ActivateCard {...props} />,
  }[step]
}

export default ActivatePhysicalCard
